module.exports = __webpack_public_path__ + "bichat-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/bichat-1.png
// module id = 1857
// module chunks = 0